import { useQuery } from '@tanstack/react-query';
import { getSubmissionCoverage } from '../../../../../api/submissions/submission-coverages.api';
import type { SubmissionCoverageDto } from '../../../../../api/submissions/submission-coverages.types';
import { getData } from '../../../../../utils/functional/fp';

/** The one query key for a submission's coverage options, shared by every quote flow. */
export const submissionCoverageKey = (submissionId: string) =>
  ['submission-coverage', submissionId] as const;

export const useQuoteOptions = (submissionId: string | undefined) =>
  useQuery<SubmissionCoverageDto>({
    queryKey: submissionCoverageKey(submissionId ?? ''),
    queryFn: () => getSubmissionCoverage(submissionId ?? '').then(getData),
    enabled: !!submissionId,
  });
